import { Link } from "react-router-dom";

export default function DetailFooter({ onSignOut }) {
    return (
        <footer
            className="border-t border-[rgba(201,168,106,0.15)] bg-[#0B0B0C] py-8"
            data-testid="private-detail-footer"
        >
            <div className="shell flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                <p className="text-[10.5px] tracking-[0.28em] uppercase text-[#9A958A]">
                    © Advanced Connected Technologies — All material
                    confidential. Do not circulate.
                </p>
                <div className="flex items-center gap-6">
                    <Link
                        to="/private"
                        className="text-[10.5px] tracking-[0.28em] uppercase text-[#C9A86A] hover:text-[#D9BC80] transition-colors duration-300"
                        data-testid="private-detail-back"
                    >
                        ← All Works
                    </Link>
                    <button
                        type="button"
                        onClick={onSignOut}
                        className="text-[10.5px] tracking-[0.28em] uppercase text-[#C9A86A] hover:text-[#D9BC80] transition-colors duration-300"
                        data-testid="private-detail-signout"
                    >
                        Sign Out →
                    </button>
                </div>
            </div>
        </footer>
    );
}
